import React, { useMemo, useState } from 'react';
import { ui } from './toolTheme';

const toTitle = (str) => str.toLowerCase().replace(/\b\w/g, (m) => m.toUpperCase());
const toSentence = (str) => {
  const s = str.trim().toLowerCase();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : '';
};
const toSnake = (str) => str.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
const toKebab = (str) => str.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

const TextCaseConverterPage = ({ setPage }) => {
  const [input, setInput] = useState('');

  const outputs = useMemo(() => ({
    UPPERCASE: input.toUpperCase(),
    lowercase: input.toLowerCase(),
    'Title Case': toTitle(input),
    'Sentence case': toSentence(input),
    snake_case: toSnake(input),
    'kebab-case': toKebab(input),
  }), [input]);

  return (
    <main style={ui.page}>
      <div style={ui.container}>
        <button onClick={() => setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>

        <div style={ui.card}>
          <h1 style={ui.sectionTitle}>Text Case Converter</h1>
          <p style={ui.sectionSub}>Convert text into multiple writing/coding cases in one click.</p>
        </div>

        <div style={{ ...ui.card, marginTop: 18 }}>
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type or paste text here..."
            rows={6}
            style={{ ...ui.textarea, fontSize: 14 }}
          />

          <div style={{ marginTop: 14, display: 'grid', gap: 10 }}>
            {Object.entries(outputs).map(([label, value]) => (
              <div key={label} style={{ border: '1px solid rgba(56,189,248,0.25)', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ padding: '8px 10px', background: 'rgba(2,6,23,0.72)', color: '#cbd5e1', fontSize: 12, fontWeight: 700 }}>{label}</div>
                <div style={{ padding: 10, color: '#e2e8f0', fontSize: 13, wordBreak: 'break-word' }}>{value || '—'}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default TextCaseConverterPage;
